<template lang="pug">
    .header
        ScrollTrigger(color='black')
        .header__container
            .header__folder()
                .header__folder-wrp()
            .header__material.header-material(:class='info.id')
                .header-material__clip
                    img(src='@/assets/img/articles/clip.png')
                .header-material__portrait
                    img(:src='require(`@/assets/img/articles/part-${curPartIndex+1}/article-${curArticIndex+1}/photos/1.jpg`)')
                .header-material__row-top
                    .header-material__full-name
                        .header-material__name(v-html='info.name')
                        .header-material__surname(v-html='info.surname')
                    .header-material__stamp
                        img(:src='require(`@/assets/img/articles/part-${curPartIndex+1}/article-${curArticIndex+1}/main/stamp.png`)')
                    .header-material__case.case(v-html='info.case')
                ul.header-material__summary
                    li.header-material__summary-item(v-for='row in content.summary')
                        span(v-for='item in row' v-html='item')
                .header-material__description(v-html='content.description.join("")')
                

            
        
</template>
<script>
// import {gsap} from 'gsap';
//import * as basicScroll from 'basicscroll';

export default {
    components: {
        ScrollTrigger: () => import('../components/ScrollTrigger.vue')
    },
    props: {
        content: Object,
        info: Object,
        curPartIndex: Number,
        curArticIndex: Number
    },
    computed: {
        paper() {
            return `../assets/img/articles/part-${this.curPartIndex}/article-${this.curArticIndex}/main/paper.jpg`;
        }
    },
    // methods: {
    //     createTimeline() {
    //         this.timeline = gsap.timeline({paused: true});
    //         this.timeline
    //             .set(this.$refs.map, {opacity: '0'})
    //             .set(this.$refs.title, {opacity: '1'})
    //             .set(this.$refs.dot, {scale: '0'})
    //             .fromTo(this.$refs.map, {opacity: '0'}, {duration: 3, opacity: '1'}, '0')
    //             .fromTo(this.$refs.title, {opacity: '1'}, {duration: 3, opacity: '0'}, '0')
    //             .fromTo(this.$refs.dot, {scale: '0'}, {duration: 3, scale: '1'}, '0');

    //         this.timeline.progress(0.0001);
    //     },
    //     createAnimation() {
    //         this.innerBlockPosition = 'fixed';
    //         this.blockPositioning();
    //         this.createTimeline();
    //         this.createScroll('top-top', 'bottom-bottom');
    //     }
    // },

    // beforeDestroy() {
    //     this.destroyAnimation();
    // }
    mounted() {
        document.addEventListener('scroll', this.scrollHandler);
        //this.createAnimation();
    }
};
</script>
<style lang="scss" scoped>
@import '../assets/css/vars.scss';
.header-material {
    //background: url(../assets/img/articles/part-1/article-1/main/paper.jpg) center / cover no-repeat;
    border-radius: 2px;
    height: fit-content;
    width: 100%;
    padding: 5vh var(--grid-column);

    font-family: var(--font-accent);
    font-weight: bold;
    font-size: 45px;
    position: relative;
    z-index: 2;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    @media screen and (--viewport-laptop) {
        //width: calc(var(--grid-column-laptop) * 17);
        width: 100%;
        padding-left: var(--grid-column-laptop);
        padding-right: var(--grid-column-laptop);
        font-size: 4vw;
    }
    @media screen and (--viewport-tablet) {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
        font-size: 6vw;
    }
    @media screen and (--viewport-mobile-lp) {
        font-size: 5vw;
    }
    @media screen and (--viewport-mobile-l) {
        font-size: 10vw;
    }
    &.japonchik {
        background-image: url(../assets/img/articles/part-1/article-1/main/paper.jpg);
    }
    &.brilliant {
        background-image: url(../assets/img/articles/part-1/article-2/main/paper.jpg);
    }
    &.svoraf {
        background-image: url(../assets/img/articles/part-1/article-3/main/paper.jpg);
    }
    &.mongol {
        background-image: url(../assets/img/articles/part-1/article-3/main/paper.jpg);
    }
    &.seka {
        background-image: url(../assets/img/articles/part-1/article-3/main/paper.jpg);
    }
    &.sever {
        background-image: url(../assets/img/articles/part-1/article-3/main/paper.jpg);
    }
    &__row-top {
        display: flex;
        padding-left: calc(var(--grid-column) * 5);
        justify-content: space-between;
        align-items: flex-start;
        position: relative;
        @media screen and (--viewport-laptop) {
            padding-left: calc(var(--grid-column-laptop) * 4);
        }
        @media screen and (--viewport-tablet) {
            padding-left: calc(var(--grid-column-mobile) * 5);
        }
        @media screen and (--viewport-mobile-l) {
            padding: 0 var(--grid-column-mobile);
        }
    }
    &__clip {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        transform: translateY(-24.5%);
        left: 10%;
        @media screen and (--viewport-mobile-l) {
            left: 30%;
        }
    }
    &__portrait {
        position: absolute;
        top: 0;
        left: 0;
        // top: -5vh;
        // left: calc(var(--grid-column) * -2);
        width: calc(var(--grid-column) * 5);
        transform: rotate(-5deg);
        transform-origin: 80% 0%;
        z-index: 1;
        img {
            display: block;
            width: 100%;
            height: auto;
        }
        @media screen and (--viewport-laptop) {
            width: calc(var(--grid-column-laptop) * 5);
            left: calc(var(--grid-column-laptop) * -1);
        }
        @media screen and (--viewport-tablet) {
            transform: rotate(0);
            width: calc(var(--grid-column-mobile) * 3);
            left: var(--grid-column-mobile);
        }
        @media screen and (--viewport-mobile-l) {
            position: static;
            width: calc(var(--grid-column-mobile) * 7);
            margin: 0 auto 3vh;
        }
    }
    &__full-name {
        font-size: 1em;
        line-height: 1;
        margin-bottom: 3vh;
        @media screen and (--viewport-mobile-l) {
            margin: 0 auto 3vh;
        }
    }
    &__stamp {
        position: absolute;
        right: 0;
        top: 0;
        transform: rotate(10deg);
        transform-origin: 100% 0%;
        @media screen and (--viewport-tablet) {
            right: auto;
            top: 110%;
            left: 4%;
            z-index: 2;
            width: calc(var(--grid-column-mobile) * 4);
        }
        @media screen and (--viewport-mobile-l) {
            right: 0;
            left: auto;
            top: auto;
            bottom: 120%;
            width: calc(var(--grid-column-mobile) * 6);
            transform: rotate(-10deg);
            transform-origin: 100% 100%;
        }
    }
    &__case {
        font-size: 15px;
        padding-top: 0.7em;
        @media screen and (--viewport-laptop) {
            display: none;
        }
    }
    &__summary {
        padding: 3vh calc(var(--grid-column) * 1) 3vh calc(var(--grid-column) * 5);
        font-size: 0.6em;
        position: relative;
        @media screen and (--viewport-laptop) {
            padding: 0 calc(var(--grid-column-laptop) * 1) 3vh calc(var(--grid-column-laptop) * 4);
        }
        @media screen and (--viewport-tablet) {
            padding-left: calc(var(--grid-column-mobile) * 5);
        }
        @media screen and (--viewport-mobile-lp) {
            padding-bottom: 10vh;
        }
        @media screen and (--viewport-mobile-l) {
            padding: 0 var(--grid-column-mobile) 3vh;
            font-size: 0.5em;
        }
        &::before,
        &::after {
            content: '';
            background: url(../assets/img/border.svg) center left / contain;
            position: absolute;
            width: 100%;
            height: 5px;
            left: 0;
            border-radius: 5px;
            @media screen and (--viewport-mobile-l) {
                width: calc(var(--grid-column-mobile) * 9);
                left: var(--grid-column-mobile);
            }
        }
        &::before {
            top: 0;
            @media screen and (--viewport-laptop) {
                display: none;
            }
        }
        &::after {
            bottom: 0;
        }
        &-item {
            display: flex;
            // flex-wrap: wrap;
            // justify-content: space-between;
            @media screen and (--viewport-tablet) {
                display: block;
            }
            span:first-child {
                text-decoration: underline;
                padding-right: 0.5em;
            }
        }
    }
    &__description {
        padding: 3vh calc(var(--grid-column) * 1) 0;
        font-size: 0.4em;
        @media screen and (--viewport-laptop) {
            padding: 3vh calc(var(--grid-column-laptop) * 1) 0;
        }
        @media screen and (--viewport-tablet) {
            padding: 3vh calc(var(--grid-column-mobile) * 1) 0;
            font-size: 0.5em;
        }
    }
}

.header {
    min-height: 100vh;
    min-height: calc(100 * var(--vh));
    background: url(../assets/img/articles/table.jpg) center / cover no-repeat;
    overflow: hidden;
    display: flex;
    &__container {
        width: var(--grid-width);
        height: 100%;
        margin: auto;
        padding: 90px calc(var(--grid-column) * 2);
        position: relative;
        @media screen and (--viewport-laptop) {
            width: 100%;
            padding: 50px calc(var(--grid-column-laptop) * 3);
        }
        @media screen and (--viewport-tablet) {
            background: url(../assets/img/articles/table-mob.jpg) center / cover no-repeat;
            padding: 50px var(--grid-column-mobile);
        }
    }
    &__folder {
        position: absolute;
        top: 0;
        //left: calc(var(--grid-column) * 3);
        left: 0;
        padding: 90px calc(var(--grid-column) * 2);
        // width: calc(var(--grid-column) * 17);
        width: 100%;
        height: 100%;
        @media screen and (--viewport-laptop) {
            padding: 50px calc(var(--grid-column-laptop) * 3);
        }
        @media screen and (--viewport-tablet) {
            padding: 50px var(--grid-column-mobile);
        }
        @media screen and (--viewport-mobile-l) {
            padding: 50px 0 0;
        }
        &-wrp {
            width: 100%;
            height: 100%;
            transform: rotate(5deg) translateX(5%);
            transform-origin: 50% 50%;
            background: url(../assets/img/articles/folder.png) center / 100% 100% no-repeat;
            @media screen and (--viewport-laptop) {
                transform: rotate(5deg);
            }
            @media screen and (--viewport-mobile-l) {
                transform: rotate(0);
                background-size: 120% 100%;
            }
            img {
                display: block;
                width: 100%;
                height: auto;
            }
        }
    }
}
/*.container {
    height: 200vh;
    // height: calc(var(--vh) * 300);
    position: relative;
    background-color: #555;

    @media screen and (--viewport-tablet) {
        height: 200vh;
    }
}

.header {
    position: relative;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    // height: calc(var(--vh) * 100);
    background-color: var(--theme);
    display: flex;
    @media screen and (--viewport-tablet) {
        padding: 28px 0;
    }
    @media screen and (--viewport-mobile-lp) {
        padding: 28px 0;
    }

    @media screen and (--viewport-tablet) {
        width: 100vw;
    }

    &__map-wrap {
        opacity: 0;
        will-change: opacity;
        width: var(--grid-width);
        margin: auto;
        position: relative;

        img {
            @media screen and (--viewport-tablet) {
                width: 100%;
                height: auto;
            }
            @media screen and (--viewport-mobile-lp) {
                height: 100%;
                width: auto;
            }
        }
        @media (--viewport-laptop) {
            width: 100%;
        }

        @media screen and (--viewport-tablet) {
            height: fit-content;
            width: 100%;
            //padding: 28px 0;
        }
        @media screen and (--viewport-mobile-lp) {
            width: fit-content;
            height: 100%;
            //padding: 28px 0;
        }
    }

    &__title {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-family: var(--font-accent);
        font-weight: 800;
        font-size: 9.72vw;
        line-height: 110%;
        text-align: center;
        opacity: calc(1 - var(--opacity));
        will-change: opacity;
    }

    &.fixed {
        position: fixed;
        top: 0;
        left: 0;
    }

    &.bottom {
        bottom: 0;
        top: auto;
    }

    &__next {
        position: absolute;
        //bottom: 50px;
        top: calc(var(--vh) * 95);
        width: 100%;
        left: 0;
        color: black;
        text-align: center;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: bold;

        @media (--viewport-tablet) {
            bottom: unset;
            top: 85vh;
            top: calc(var(--vh) * 85);
        }

        span {
            &:after {
                content: '▼';
                display: inline-block;
                margin-left: 5px;
            }
        }
    }
}

.city {
    position: absolute;
    display: flex;
    align-items: center;
    width: fit-content;

    &__dot {
        transform-origin: center;
        height: 1rem;
        width: 1rem;
        border-radius: 50%;
        background-color: var(--theme);
        margin-right: 10px;
        transform: scale(0);
        will-change: transform;

        &.reverse {
            margin-left: 10px;
            margin-right: 0;
        }
    }

    &__name {
        font-family: var(--font-main);
        font-weight: bold;
        font-size: 0.75rem;
        line-height: 0.75rem;
        text-transform: uppercase;
        color: var(--theme);

        &.reverse {
            order: -1;
        }
    }
}*/
</style>
